import { IModule } from '@elliemae/pui-scripting-object';
import { Transport, LogMessage } from '../types.js';

/**
 * get parent app transport handler. Strips base log schema fields before forwarding to the host module.
 * @param module {@link IModule} parent application scripting object
 * @returns parent app transport handler
 */
export const parentApp = (module: IModule): Transport => ({
  log: async (msg: LogMessage) => {
    try {
      const {
        index,
        host,
        environment,
        level,
        resourceId,
        resourceType,
        appVersion,
        team,
        location,
        correlationId,
        instanceId,
        customerId,
        userId,
        loanId,
        context,
        '@timestamp': _ts, // eslint-disable-line @typescript-eslint/naming-convention
        ...rest
      } = msg;
      return await module.log(rest, level);
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
      return false;
    }
  },
});
